import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

let scene, camera, renderer, smartphoneModel;
let screenMesh; // Hold the screen mesh globally to allow dynamic updates
let directionalLight;
let currentImagePath;

let currentNotchType = 'currentNotch'; // Default to current notch




function init() {
    scene = new THREE.Scene();
//    scene.background = new THREE.Color(0xffffff);

    // Define the initial aspect ratio and size
    const aspectRatio = 9 / 16;
    const initialHeight = window.innerHeight; // Use the full window height
    const initialWidth = initialHeight * aspectRatio; // Calculate initial width based on the aspect ratio

    camera = new THREE.PerspectiveCamera(75, aspectRatio, 0.1, 1000);
    camera.position.set(0, 0.5, 2.5);

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true});
    renderer.setSize(initialWidth, initialHeight); // Use the initial calculated dimensions
   
    renderer.setPixelRatio(window.devicePixelRatio); // Set the renderer pixel ratio for high-DPI devices


    document.getElementById('threejs-scene').appendChild(renderer.domElement); // Ensure you have a container with this ID in your HTML

    const ambientLight = new THREE.AmbientLight(0xfff, 1);
    scene.add(ambientLight);

    directionalLight = new THREE.DirectionalLight(0xfffcf0, 4);
    directionalLight.position.set(0, 3, 2);
    scene.add(directionalLight);

    console.log("Loading the smartphone model...");
    loadSmartphoneModel();

    window.addEventListener('resize', onWindowResize, false);

    animate();
}

function loadSmartphoneModel() {
    const loader = new GLTFLoader();
    loader.load('model.glb', function(gltf) {
        console.log("Model loaded successfully.");
        smartphoneModel = gltf.scene;

         // Rotate the entire model by 180 degrees around the Y axis
         smartphoneModel.rotation.y = Math.PI; // π radians = 180 degrees



        scene.add(smartphoneModel);
        createScreenPlane(); // Create the screen plane after the model has loaded
    }, undefined, function(error) {
        console.error('An error happened while loading the model:', error);
    });
}

function createScreenPlane() {
    // Adjust the size according to your model's scale and screen size
    const screenGeometry = new THREE.PlaneGeometry(0.99, 1.89); // Example size, adjust as needed
    const screenMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000, // Initially black or consider making it fully transparent
        transparent: true,
        opacity: 0, // Start fully transparent
        side: THREE.DoubleSide
    });
    screenMesh = new THREE.Mesh(screenGeometry, screenMaterial);

    // Adjust these positions to correctly place the screen on the smartphone model
    screenMesh.position.set(0, 1.008, -0.0857); // Position relative to the parent model
    screenMesh.rotation.y = Math.PI; // π radians = 180 degrees

    if (smartphoneModel) {
        // Add the screen mesh as a child of the smartphone model
        smartphoneModel.add(screenMesh);
    } else {
        console.error("Smartphone model not loaded when attempting to create screen plane.");
    }
}


window.applyTexture = function(imagePath) {

    currentImagePath = imagePath; // Update the variable whenever a new texture is applied



    const img = new Image();
    img.crossOrigin = "anonymous"; // Needed for external URLs
    img.onload = function() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const width = img.width;
        const height = img.height;
        canvas.width = width;
        canvas.height = height;

        // Adjust the switch statement to use the functions without reassigning canvas
        switch (currentNotchType) {
            case 'noNotch':
                createCanvasNoNotch(canvas, ctx, img); // Assuming these functions now modify the canvas directly
                break;
            case 'currentNotch':
                createCanvasCurrentNotch(canvas, ctx, img);
                break;
            case 'pillNotch':
                createCanvasPillNotch(canvas, ctx, img);
                break;
            default:
                console.error('Unknown notch type');
                return;
        }



        const texture = new THREE.Texture(canvas);
        texture.needsUpdate = true;
        texture.colorSpace = THREE.SRGBColorSpace;




        if (screenMesh) {
            screenMesh.material = new THREE.MeshPhysicalMaterial({
              
                map: texture, // Apply the canvas texture as the main texture
                emissiveMap: texture, // Use the same texture as the emissive map
               transparent: true, // Enable transparency
                opacity: 1, // Fully opaque now that we're applying the image
                emissive: 0xfcf9d7, // This makes the material emit light
                emissiveIntensity: 0.3, // Adjust the intensity of the light
                
                reflectivity: 0.9, // Adjust reflectivity for a glass-like look
                roughness: 0.0, // Lower roughness for smoother surface
                metalness: 0.0, // Adjust for a slight metallic sheen
                ior: 3, // Adjust index of refraction for realism

                
            });



            screenMesh.material.needsUpdate = true;
            console.log("Rounded corner image with glass-like effect successfully applied as texture.");
            renderer.render(scene, camera);
        }
    };
    img.src = imagePath;
};

function createCanvasNoNotch(canvas,ctx,img) {

    const width = img.width;
    const height = img.height;
    canvas.width = width;
    canvas.height = height;

    const cornerRadius = 180; // Overall corner radius

    ctx.beginPath();
    ctx.moveTo(cornerRadius, 0);
    ctx.lineTo(width - cornerRadius, 0);
    ctx.quadraticCurveTo(width, 0, width, cornerRadius);
    ctx.lineTo(width, height - cornerRadius);
    ctx.quadraticCurveTo(width, height, width - cornerRadius, height);
    ctx.lineTo(cornerRadius, height);
    ctx.quadraticCurveTo(0, height, 0, height - cornerRadius);
    ctx.lineTo(0, cornerRadius);
    ctx.quadraticCurveTo(0, 0, cornerRadius, 0);
    ctx.closePath();
    ctx.clip();

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

}


function createCanvasPillNotch(canvas, ctx, img) {
    const width = img.width;
    const height = img.height;
    canvas.width = width;
    canvas.height = height;

    // Prepare the canvas with rounded corners
    const cornerRadius = 180; // Overall corner radius for the canvas background

    // Clip the canvas with rounded corners
    ctx.beginPath();
    ctx.moveTo(cornerRadius, 0);
    ctx.lineTo(width - cornerRadius, 0);
    ctx.quadraticCurveTo(width, 0, width, cornerRadius);
    ctx.lineTo(width, height - cornerRadius);
    ctx.quadraticCurveTo(width, height, width - cornerRadius, height);
    ctx.lineTo(cornerRadius, height);
    ctx.quadraticCurveTo(0, height, 0, height - cornerRadius);
    ctx.lineTo(0, cornerRadius);
    ctx.quadraticCurveTo(0, 0, cornerRadius, 0);
    ctx.closePath();
    ctx.clip();

    // Draw the image within the clipped area
    ctx.drawImage(img, 0, 0, width, height);

    // Pill-shaped notch settings
    const pillWidth = 250; // Width of the pill-shaped notch
    const pillHeight = 80; // Height of the pill-shaped notch
    const pillTopY = 30; // Vertical position of the top of the pill-shaped notch
    const pillCornerRadius = 40; // Corner radius for the pill-shaped notch

    // Calculate positions for the pill-shaped notch
    const pillStartX = (width / 2) - (pillWidth / 2);
    const pillEndX = (width / 2) + (pillWidth / 2);

    // Draw the pill-shaped notch with rounded corners
    ctx.fillStyle = 'black';
    ctx.beginPath();
    
    // Start at the top left corner of the pill
    ctx.moveTo(pillStartX + pillCornerRadius, pillTopY);

    // Top line
    ctx.lineTo(pillEndX - pillCornerRadius, pillTopY);
    // Top right corner
    ctx.arcTo(pillEndX, pillTopY, pillEndX, pillTopY + pillCornerRadius, pillCornerRadius);
    // Right line
    ctx.lineTo(pillEndX, pillTopY + pillHeight - pillCornerRadius);
    // Bottom right corner
    ctx.arcTo(pillEndX, pillTopY + pillHeight, pillEndX - pillCornerRadius, pillTopY + pillHeight, pillCornerRadius);
    // Bottom line
    ctx.lineTo(pillStartX + pillCornerRadius, pillTopY + pillHeight);
    // Bottom left corner
    ctx.arcTo(pillStartX, pillTopY + pillHeight, pillStartX, pillTopY + pillHeight - pillCornerRadius, pillCornerRadius);
    // Left line
    ctx.lineTo(pillStartX, pillTopY + pillCornerRadius);
    // Top left corner
    ctx.arcTo(pillStartX, pillTopY, pillStartX + pillCornerRadius, pillTopY, pillCornerRadius);

    ctx.fill();
}



function createCanvasCurrentNotch(canvas,ctx,img) {

    const width = img.width;
    const height = img.height;
    canvas.width = width;
    canvas.height = height;

    // Define the radius for rounded corners
    const cornerRadius = 180;
    const notchCornerRounding = 10;

    // Existing notch dimensions
    const notchWidth = 450;
    const notchHeight = 90;
    const notchBottomWidth = 400;
    const notchTopY = 10;
    const notchBottomY = notchTopY + notchHeight;
    const notchMiddleX = width / 2;
    const notchLeftX = notchMiddleX - notchBottomWidth / 2;
    const notchRightX = notchMiddleX + notchBottomWidth / 2;

    ctx.beginPath();
    // Start from the bottom left corner and move counter-clockwise
    ctx.moveTo(cornerRadius, height);
    ctx.lineTo(width - cornerRadius, height);
    ctx.quadraticCurveTo(width, height, width, height - cornerRadius);
    ctx.lineTo(width, cornerRadius);
    ctx.quadraticCurveTo(width, 0, width - cornerRadius, 0);

    // Notch right side
    ctx.lineTo(notchMiddleX + notchWidth / 2, 0);

    // Top right of notch
    ctx.lineTo(notchMiddleX + notchWidth / 2, notchTopY - notchCornerRounding);
    ctx.quadraticCurveTo(notchMiddleX + notchWidth / 2, notchTopY, notchMiddleX + notchWidth / 2 - notchCornerRounding, notchTopY);

    // Notch bottom right
    ctx.lineTo(notchRightX + notchCornerRounding, notchBottomY);
    ctx.quadraticCurveTo(notchRightX, notchBottomY, notchRightX, notchBottomY + notchCornerRounding);

    // Notch bottom left
    ctx.lineTo(notchLeftX, notchBottomY + notchCornerRounding);
    ctx.quadraticCurveTo(notchLeftX, notchBottomY, notchLeftX - notchCornerRounding, notchBottomY);

    // Top left of notch
    ctx.lineTo(notchMiddleX - notchWidth / 2 + notchCornerRounding, notchTopY);
    ctx.quadraticCurveTo(notchMiddleX - notchWidth / 2, notchTopY, notchMiddleX - notchWidth / 2, notchTopY - notchCornerRounding);

    // Notch left side
    ctx.lineTo(notchMiddleX - notchWidth / 2, 0);
    
    // Complete the path
    ctx.lineTo(cornerRadius, 0);
    ctx.quadraticCurveTo(0, 0, 0, cornerRadius);
    ctx.lineTo(0, height - cornerRadius);
    ctx.quadraticCurveTo(0, height, cornerRadius, height);

    ctx.closePath();
    ctx.clip();

    // Draw the image
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

}







function onWindowResize() {
    // Adjust the renderer and camera aspect ratio while maintaining a 9:16 aspect ratio
    const newHeight = window.innerHeight;
    const newWidth = window.innerHeight * (9 / 16);
    camera.aspect = 9 / 16;
    camera.updateProjectionMatrix();
    renderer.setSize(newWidth, newHeight);
}

// Declare a global variable to hold the rotation target
let targetRotationY = Math.PI * 0.9;

// Modify the animate function
function animate() {
  requestAnimationFrame(animate);

  // Gradually move the smartphoneModel.rotation.y towards targetRotationY
  if (smartphoneModel) {
    const deltaRotationY = targetRotationY - smartphoneModel.rotation.y;
    smartphoneModel.rotation.y += deltaRotationY * 0.05; // The multiplier controls the "elasticity"
  }

  renderer.render(scene, camera);
}



function switchModel(modelPath) {
    // Remove the current model from the scene
    if (smartphoneModel) {
        scene.remove(smartphoneModel);
        smartphoneModel = null; // Clear the reference
    }

    // Load the new model
    const loader = new GLTFLoader();
    loader.load(modelPath, function(gltf) {
        smartphoneModel = gltf.scene;
        smartphoneModel.rotation.y = Math.PI; // Adjust rotation as needed
        scene.add(smartphoneModel);

        // Ensure the createScreenPlane function is updated to support re-creation or identification of the screen mesh
        createScreenPlane(); // Recreate or update the screen plane for the new model

        // Reapply the texture to the new model's screen if an image has already been uploaded
        if (currentImagePath) {
            // Ensure the applyTexture function is updated or validated to correctly apply the texture to the newly identified screen mesh
            applyTexture(currentImagePath); // Reapply the texture using the existing imagePath
        }
    }, undefined, function(error) {
        console.error('An error happened while loading the model:', error);
    });
}





// Listen for slider changes
document.getElementById('rotation-slider').addEventListener('input', function() {
  // Update the target rotation based on the slider's value
  // Convert degrees to radians since Three.js uses radians
  const degrees = parseInt(this.value);
  targetRotationY = THREE.MathUtils.degToRad(degrees);
});

document.getElementById('light-rotation-slider').addEventListener('input', function() {
    const degrees = parseInt(this.value);
    const radians = THREE.MathUtils.degToRad(degrees);

    // Assuming the light should rotate around the Y axis at a fixed radius
    const radius = 5; // Adjust based on your scene's scale
    const x = radius * Math.sin(radians);
    const z = radius * Math.cos(radians);

    // Update light position
    directionalLight.position.set(x, directionalLight.position.y, z);

    // Re-render the scene after updating the light position
    renderer.render(scene, camera);
});




document.getElementById('snapshotBtn').addEventListener('click', function() {
    // Save the original size
    const originalSize = {
        width: renderer.domElement.width,
        height: renderer.domElement.height
    };

    // Increase the size for a higher resolution snapshot
    const scaleFactor = 4; // Example: 4 times the original size
    const width = originalSize.width * scaleFactor;
    const height = originalSize.height * scaleFactor;

    // Update renderer and camera aspect ratio to the new size
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    // Render the scene with the temporary size
    renderer.render(scene, camera);

    // Create an off-screen canvas for cropping
    const cropCanvas = document.createElement('canvas');
    const cropCtx = cropCanvas.getContext('2d');

    // Calculate crop dimensions
    const cropWidth = width * 0.6; // 10% from each side
    const cropHeight = height * 0.6; // Bottom 30% cropped
    cropCanvas.width = cropWidth;
    cropCanvas.height = cropHeight;

    // Extract the part of the image to be retained
    // sx, sy, sWidth, sHeight are calculated based on the crop requirements
    const sx = width * 0.1; // Start 10% from the left
    const sy = 0; // Start from the top
    const sWidth = width * 0.8; // 80% of the width
    const sHeight = height * 0.7; // Top 70% of the height

    // Draw the cropped image onto the off-screen canvas
    cropCtx.drawImage(renderer.domElement, sx, sy, sWidth, sHeight, 0, 0, cropWidth, cropHeight);

    // Use the cropped canvas to create a Data URL
    const dataUrl = cropCanvas.toDataURL('image/png');

    // Create a temporary link element for downloading the image
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = 'threejs-scene-snapshot.png'; // Name of the file to be downloaded
    link.click(); // Programmatically click the link to trigger the download

    // Restore the renderer and camera to their original size and aspect ratio
    renderer.setSize(originalSize.width, originalSize.height, false);
    camera.aspect = originalSize.width / originalSize.height;
    camera.updateProjectionMatrix();
});





// Call this function to initialize the event listener and start the animation loop
init();


// Event listener for model selection buttons
document.querySelectorAll('.model-btn').forEach(button => {
    button.addEventListener('click', function() {
      const modelPath = this.getAttribute('data-model');
      switchModel(modelPath);
    });
  });


  document.getElementById('btnNoNotch').addEventListener('click', function() {
    currentNotchType = 'noNotch'; // Update the notch type
    if (currentImagePath) {
        applyTexture(currentImagePath); // Reapply the texture with the new canvas type
    }
});

document.getElementById('btnCurrentNotch').addEventListener('click', function() {
    currentNotchType = 'currentNotch'; // Update the notch type
    if (currentImagePath) {
        applyTexture(currentImagePath); // Reapply the texture with the new canvas type
    }
});

document.getElementById('btnPillNotch').addEventListener('click', function() {
    currentNotchType = 'pillNotch'; // Update the notch type
    if (currentImagePath) {
        applyTexture(currentImagePath); // Reapply the texture with the new canvas type
    }
});


